import { render, staticRenderFns } from "./PerformanceIndicatorForm.vue?vue&type=template&id=796f6be1"
import script from "./PerformanceIndicatorForm.vue?vue&type=script&lang=js"
export * from "./PerformanceIndicatorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports